import { getGuessLocale } from 'utils/functions/Date';

export const formatCount = (count?: number | string) => {
  const numberFormat = new Intl.NumberFormat(getGuessLocale());
  return numberFormat.format(Number(count));
};
